import React, { useEffect, useRef, useState } from 'react';
import InputMask from 'react-input-mask';
import { message } from 'antd';
import { TWModal, TWButton, TWInput, FieldLabel } from '../../../components/ui';
import referralApi from '../../../services/referralApi';

const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
const digitsOf = (value) => value.replace(/\D/g, '');

// Tek bileşen iki kanalı `channel` prop'uyla yönetir ('sms' | 'email').
const ShareModal = ({ open, channel, onClose }) => {
  const cancelRef = useRef(null);
  const [value, setValue] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const isSms = channel === 'sms';

  // Modal her açıldığında veya kanal değiştiğinde alanı sıfırla.
  useEffect(() => {
    if (open) {
      setValue('');
      setError('');
      setLoading(false);
    }
  }, [open, channel]);

  const handleSend = async () => {
    if (isSms) {
      if (digitsOf(value).length !== 10) {
        setError('Enter a valid 10-digit phone number');
        return;
      }
    } else if (!isValidEmail(value)) {
      setError('Enter a valid email address');
      return;
    }
    setError('');
    setLoading(true);
    try {
      if (isSms) {
        await referralApi.shareSms({ toPhone: `+1${digitsOf(value)}` });
      } else {
        await referralApi.shareEmail({ toEmail: value.trim() });
      }
      message.success('Invite sent');
      onClose();
    } catch (err) {
      const apiMessage =
        typeof err?.response?.data === 'string'
          ? err.response.data
          : err?.response?.data?.message || 'Failed to send invite';
      message.error(apiMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <TWModal
      open={open}
      onClose={onClose}
      title={isSms ? 'Invite by SMS' : 'Invite by Email'}
      description="We'll send them your referral link so they can sign up."
      size="md"
      initialFocus={cancelRef}
      showCloseButton
      footer={
        <div className="flex justify-end gap-2">
          <TWButton
            ref={cancelRef}
            label="Cancel"
            disabled={loading}
            onClick={onClose}
          />
          <TWButton
            variant="primary"
            label={loading ? 'Sending…' : 'Send Invite'}
            loading={loading}
            onClick={handleSend}
          />
        </div>
      }
    >
      {isSms ? (
        <div>
          <FieldLabel>Phone number</FieldLabel>
          <InputMask
            mask="(999) 999-9999"
            maskPlaceholder=" "
            value={value}
            onChange={(e) => setValue(e.target.value)}
            disabled={loading}
            type="tel"
            placeholder="(555) 123-4567"
            className="block h-10 w-full rounded-md border border-slate-300 bg-white px-3 text-sm text-slate-900 placeholder-slate-400 transition focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-100 dark:placeholder-slate-500"
          />
          {error ? (
            <p className="mt-1 text-xs text-rose-600 dark:text-rose-400">
              {error}
            </p>
          ) : null}
        </div>
      ) : (
        <TWInput
          label="Email address"
          type="email"
          placeholder="owner@restaurant.com"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          error={error}
          disabled={loading}
        />
      )}
    </TWModal>
  );
};

export default ShareModal;
